module.exports = __webpack_public_path__ + "static/footer-4bae46c54b360e31ba2582ec3c5f9d73.jpg";